import React from 'react'
import { Container } from './styles'
import Panel from '../../../../../components/Panel'
import { MAP_EXHIBITION_TYPE } from '../../../../../../../redux/dashboard-real-time';
import { OptionButton } from './components/OptionButton';

export const LocationTypeFilter = ({isCollapsed, selectedType, onChange}) => {
  const handleOptionClick = (type) => {
    if (type === selectedType) {
      onChange(null);
    } else {
      onChange(type);
    }
  };

  const isTruck = selectedType === MAP_EXHIBITION_TYPE.TRACKER_LOCATION;
  const isApp = selectedType === MAP_EXHIBITION_TYPE.APP_LOCATION;

  return (
    <Panel
      collapsible={isCollapsed}
      title="Exibir no mapa"
      isHeaderShort={true}
    >
      <Container>
        <OptionButton
          isActive={isTruck}
          onClick={() => handleOptionClick(MAP_EXHIBITION_TYPE.TRACKER_LOCATION)}
          iconName={'truck'}
          labelText={'Rastreador'}
        />
        <OptionButton
          isActive={isApp}
          onClick={() => handleOptionClick(MAP_EXHIBITION_TYPE.APP_LOCATION)}
          iconName={'phone-iphone-filled'}
          labelText={'App'}
        />
      </Container>
    </Panel>
  )
}

